var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 964 964",
    style: {
      enableBackground: "new 0 0 964 964"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F27D42;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F27D42;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,306.8c36.3,0,65.7-29.4,65.7-65.7s-29.4-65.7-65.7-65.7s-65.7,29.4-65.7,65.7S204.8,306.8,241.1,306.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.3,394.4c0-24.2,19.6-43.8,43.8-43.8H263c24.2,0,43.8,19.6,43.8,43.8v350.5c0,24.2-19.6,43.8-43.8,43.8 h-43.8c-24.2,0-43.8-19.6-43.8-43.8V394.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.2,788.7H482c24.2,0,43.8-19.6,43.8-43.8V547.7c0-65.7,131.4-109.5,131.4-21.9v219.1 c0,24.2,19.6,43.8,43.8,43.8h43.8c24.2,0,43.8-19.6,43.8-43.8V482c0-87.6-65.7-131.4-153.3-131.4s-109.5,65.7-109.5,65.7v-21.9 c0-24.2-19.6-43.8-43.8-43.8h-43.8c-24.2,0-43.8,19.6-43.8,43.8v350.5C394.4,769,414,788.7,438.2,788.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M832.5,0.1c72.6,0,131.4,58.8,131.4,131.4v700.9c0,72.6-58.8,131.4-131.4,131.4H131.5 C59,963.9,0.1,905.1,0.1,832.5V131.5C0.1,59,59,0.1,131.5,0.1H832.5z M832.5,87.7c24.2,0,43.8,19.6,43.8,43.8v700.9 c0,24.2-19.6,43.8-43.8,43.8H131.5c-24.2,0-43.8-19.6-43.8-43.8V131.5c0-24.2,19.6-43.8,43.8-43.8H832.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d7b38990149b783b1453bf6bda2a2dc1.svg";
export { ForwardRef as ReactComponent };